import { Routes } from '@angular/router';

import { AuthService } from '../../auth/auth.service';

import { PowerBiReportComponent } from './power-bi-report.component';

export const PowerBiReportRoutes: Routes = [
    {
        path: 'reports/power-bi',
        canActivate: [AuthService],
        children: [
            { path: '', redirectTo: 'reports/power-bi', pathMatch: 'full' },
            {
                path: 'view',
                component: PowerBiReportComponent,
            },
        ],
    },
];
